// This file is automatically generated. Do not edit manually.

import { ConfiguratorAppVersionWarning } from "src/api/generated/erp/configurator/management/service/configuratorAppVersionWarning";
import { PartCreationWizardSubmitData_CatalogPart } from "src/api/generated/erp/parts/catalogPart/service/partCreationWizardSubmitData";
import { PartCreationWizardSubmitData_CatalogPartBom } from "src/api/generated/erp/parts/catalogPart/service/partCreationWizardSubmitData";
import { PartCreationWizardSubmitData_SitePart } from "src/api/generated/erp/parts/catalogPart/service/partCreationWizardSubmitData";
import { PartCreationWizardSubmitData_SitePartOperation } from "src/api/generated/erp/parts/catalogPart/service/partCreationWizardSubmitData";
import { PartCreationWizardSubmitData_SalesPart } from "src/api/generated/erp/parts/catalogPart/service/partCreationWizardSubmitData";
import { PartCreationWizardSubmitData_SupplierPart } from "src/api/generated/erp/parts/catalogPart/service/partCreationWizardSubmitData";
import { PartCreationWizardSubmitData_PartWarehouseLocation } from "src/api/generated/erp/parts/catalogPart/service/partCreationWizardSubmitData";
import { PartCreationWizardResult } from "src/api/generated/erp/parts/catalogPart/service/partCreationWizardResult";
import { PartCategory } from "src/api/generated/erp/db/types/tables/partCategory";
import { ConfigurationProductFamily } from "src/api/generated/erp/db/types/tables/configurationProductFamily";
import { ErpUnit } from "src/api/generated/erp/db/types/tables/erpUnit";
import { PartWarehouseLocationView } from "src/api/generated/erp/db/types/tables/partWarehouseLocationView";
import { NumberSequence } from "src/api/generated/erp/db/types/tables/numberSequence";
import { Operation } from "src/api/generated/erp/db/types/tables/operation";
import { ProductionLineView } from "src/api/generated/erp/db/types/tables/productionLineView";
import { AccountingDimension } from "src/api/generated/erp/db/types/tables/accountingDimension";
import { SalesPartCategory } from "src/api/generated/erp/db/types/tables/salesPartCategory";
import { SalesPartPriceGroup } from "src/api/generated/erp/db/types/tables/salesPartPriceGroup";
import { CatalogPart } from "src/api/generated/erp/db/types/tables/catalogPart";
import { VatCode } from "src/api/generated/erp/db/types/tables/vatCode";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace PartCreationWizardApi {
	export async function getInitData(args: {
		siteId: number;
		templateCatalogPartId: number | null | undefined;
	}): Promise<PartCreationWizardApi_FormInitData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/productManagement/partCreationWizard/getInitData",
			method: "POST",
			data: {
				siteId: args.siteId,
				templateCatalogPartId: args.templateCatalogPartId,
			},
		});
		return response as PartCreationWizardApi_FormInitData;
	}

	export async function getConfiguratorAppVersionWarning(args: {
		configurationProductFamilyId: number;
	}): Promise<ConfiguratorAppVersionWarning | null> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/productManagement/partCreationWizard/getConfiguratorAppVersionWarning",
			method: "POST",
			data: {
				configurationProductFamilyId: args.configurationProductFamilyId,
			},
		});
		return response === "" ? null : (response as ConfiguratorAppVersionWarning | null);
	}

	export async function submit(args: {
		catalogPart: PartCreationWizardSubmitData_CatalogPart;
		catalogPartBom: PartCreationWizardSubmitData_CatalogPartBom | null | undefined;
		sitePart: PartCreationWizardSubmitData_SitePart | null | undefined;
		sitePartOperations: Array<PartCreationWizardSubmitData_SitePartOperation> | null | undefined;
		salesPart: PartCreationWizardSubmitData_SalesPart | null | undefined;
		supplierPart: PartCreationWizardSubmitData_SupplierPart | null | undefined;
		partWarehouseLocation: PartCreationWizardSubmitData_PartWarehouseLocation | null | undefined;
		templateCatalogPartId: number | null | undefined;
		templateCatalogPartRevisionId: number | null | undefined;
		publishCatalogPartRevision?: boolean;
	}): Promise<PartCreationWizardResult> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/productManagement/partCreationWizard/submit",
			method: "POST",
			data: {
				catalogPart: args.catalogPart,
				catalogPartBom: args.catalogPartBom,
				sitePart: args.sitePart,
				sitePartOperations: args.sitePartOperations,
				salesPart: args.salesPart,
				supplierPart: args.supplierPart,
				partWarehouseLocation: args.partWarehouseLocation,
				templateCatalogPartId: args.templateCatalogPartId,
				templateCatalogPartRevisionId: args.templateCatalogPartRevisionId,
				publishCatalogPartRevision: args.publishCatalogPartRevision,
			},
		});
		return response as PartCreationWizardResult;
	}
}

export interface PartCreationWizardApi_FormInitData {
	categoryOptions: Array<PartCategory>;
	configurationProductFamilyOptions: Array<ConfigurationProductFamily>;
	erpUnitOptions: Array<ErpUnit>;
	givingWarehouseLocationOptions: Array<PartWarehouseLocationView>;
	inventoryLevelEnabledByDefault: boolean;
	numberSequenceOptions: Array<NumberSequence>;
	operationOptions: Array<Operation>;
	partCategoryOptions: Array<PartCategory>;
	productionLineOptions: Array<ProductionLineView>;
	salesPartAccountingDimensions: Array<AccountingDimension>;
	salesPartCategoryOptions: Array<SalesPartCategory>;
	salesPriceGroupOptions: Array<SalesPartPriceGroup>;
	siteId: number;
	templateCatalogPart: CatalogPart | null | undefined;
	vatCodeOptions: Array<VatCode>;
}
